import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import EntryOverview from '@/pages/home/components/EntryOverview';
import UpdateLog from '@/pages/home/components/UpdateLog';
import UrlDirectory from '@/pages/home/components/UrlDirectory';
import AccessSteps from '@/pages/home/components/AccessSteps';
import VerifyChecklist from '@/pages/home/components/VerifyChecklist';
import PermanentEntry from '@/pages/home/components/PermanentEntry';
import SafetyTips from '@/pages/home/components/SafetyTips';
import Faq from '@/pages/home/components/Faq';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="w-full bg-background-50">
      <Header />
      <main>
        <Hero />
        <EntryOverview />
        <UpdateLog />
        <UrlDirectory />
        <AccessSteps />
        <VerifyChecklist />
        <PermanentEntry />
        <SafetyTips />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}